import PropTypes from 'prop-types';
import React from 'react';
import { Provider } from 'react-redux';
import { Route } from 'react-router-dom';
import MainLayout from './modules/layout/main.layout';

const Root = ({ store }) => (
  <Provider store={store}>
    <div style={{ height: '100%' }}>
      <Route path="/" render={props => <MainLayout {...props}/>} />
    </div>
  </Provider>
);

Root.propTypes = {
  store: PropTypes.object.isRequired
};

export default Root;
